module.exports = __webpack_public_path__ + "static/media/1010257.006acf3a.jpg";